<template>
  <div class="app-layout app-layout-ecatalogue">
    <e-catalogue-header :open="noop" :openOrder="goOrderHistory" :route-prefix="routePrefix" :fixed-store="true" />
    <b-container fluid>
      <slot />
    </b-container>
  </div>
</template>

<script>
import ECatalogueHeader from '@/components/ECatalogueHeader.vue';
import { ECATALOGUE_STORAGE_KEYS, getECatalogueStorageKey } from '@/utils/ecatalogueStorage';

export default {
  name: 'OpenCustomerECatalogueLayout',
  components: { ECatalogueHeader },
  computed: {
    routePrefix() {
      return '/open-customer';
    }
  },
  mounted() {
    const defaultStore = {
      pincodes: ['734004'],
      storeName: 'SPENCERS WHOLESALE BAZAAR (B2B)',
      storeid: 'S117'
    };
    localStorage.setItem(
      getECatalogueStorageKey(this.$route, ECATALOGUE_STORAGE_KEYS.STORE, this.routePrefix),
      JSON.stringify(defaultStore)
    );
  },
  methods: {
    noop() {},
    goOrderHistory() {
      this.$router.push(`${this.routePrefix}/eOrderHistory`);
    }
  }
};
</script>
